(() => {
  'use strict';

  if (window.__oneLuxuryPurchaseIntegrityInitialized) return;
  window.__oneLuxuryPurchaseIntegrityInitialized = true;

  const POLICY_SELECTOR = 'script[type="application/json"][data-one-luxury-purchase-policy]';
  const CART_FORM_SELECTOR = 'form[action*="/cart/add"], product-form form';
  const PAYMENT_SELECTOR = '.shopify-payment-button, [data-shopify="payment-button"], [data-shopify-buy-it-now-button]';
  let scheduled = false;

  function policies() {
    const result = new Map();
    document.querySelectorAll(POLICY_SELECTOR).forEach((node) => {
      try {
        const policy = JSON.parse(node.textContent);
        if (policy?.productId) result.set(String(policy.productId), policy);
      } catch (error) {
        console.error('1Luxury purchase policy could not be parsed.', error);
      }
    });
    return result;
  }

  function productIdFor(node) {
    const owner = node.closest('[data-product-id]');
    return String(
      node.dataset?.productId ||
      owner?.dataset?.productId ||
      owner?.getAttribute?.('data-product-id') ||
      ''
    );
  }

  function selectedVariantId(form, policy) {
    const field = form?.querySelector('[name="id"]');
    if (field?.value) return String(field.value);

    const productRoot = form?.closest('product-info, [data-product-id]');
    const stateId = productRoot?.querySelector('[data-one-luxury-availability]')?.dataset?.availabilityVariantId;
    if (stateId) return String(stateId);

    if (policy?.variants?.length === 1) return String(policy.variants[0].id);
    return '';
  }

  function decision(form, policyMap = policies()) {
    const productId = productIdFor(form);
    const policy = policyMap.get(productId);
    if (!policy) return { governed: false, allowed: true };

    const variantId = selectedVariantId(form, policy);
    const variant = policy.variants.find((item) => String(item.id) === variantId);
    const allowed = Boolean(
      variant &&
      variant.purchasable === true &&
      variant.available === true &&
      variant.ctaType === 'cart' &&
      Number(variant.price) >= 500
    );

    return {
      governed: true,
      allowed,
      mode: variant?.mode || (variantId ? 'unrecognized_variant' : 'choose_options'),
      productId,
      variantId
    };
  }

  function announceBlocked(form, result) {
    const root = form.closest('product-info, .m-product-info--wrapper, [data-product-id]') || form.parentElement;
    if (!root) return;

    let status = root.querySelector('[data-one-luxury-purchase-integrity-status]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.oneLuxuryPurchaseIntegrityStatus = '';
      status.className = 'one-luxury-purchase-integrity-status';
      status.setAttribute('role', 'alert');
      root.append(status);
    }
    status.textContent = result.mode === 'choose_options'
      ? 'Choose every required option before continuing.'
      : 'Direct checkout is unavailable for this selection. Use the purchase option shown on this page.';

    const safeAction = root.querySelector('[data-availability-cta], [data-one-luxury-sticky-choose-options], .one-luxury-availability__action');
    safeAction?.focus?.({ preventScroll: true });
  }

  function sanitize(policyMap = policies()) {
    document.querySelectorAll(CART_FORM_SELECTOR).forEach((form) => {
      const result = decision(form, policyMap);
      if (!result.governed) return;

      form.dataset.oneLuxuryPurchasable = result.allowed ? 'true' : 'false';
      form.querySelectorAll('button[name="add"], [data-add-to-cart]').forEach((button) => {
        button.disabled = !result.allowed;
        button.setAttribute('aria-disabled', result.allowed ? 'false' : 'true');

        if (result.allowed) {
          const text = button.querySelector('.m-add-to-cart--text, [data-add-to-cart-text]');
          const expected = button.dataset.atcText || window.MinimogStrings?.addToCart || '';
          if (text && expected && text.textContent.trim() !== expected.trim()) {
            text.textContent = expected;
          }
        }
      });

      if (!result.allowed) {
        form.querySelectorAll(PAYMENT_SELECTOR).forEach((payment) => payment.remove());
      }
    });
  }

  function scheduleSanitize() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      sanitize();
    });
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.(CART_FORM_SELECTOR);
    if (!form) return;

    const result = decision(form);
    if (!result.governed || result.allowed) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    announceBlocked(form, result);
  }, true);

  document.addEventListener('click', (event) => {
    const payment = event.target.closest?.(PAYMENT_SELECTOR);
    const form = payment?.closest?.('form');
    if (!form) return;

    const result = decision(form);
    if (!result.governed || result.allowed) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    announceBlocked(form, result);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSanitize, { once: true });
  } else {
    scheduleSanitize();
  }

  document.addEventListener('variant:changed', scheduleSanitize);
  document.addEventListener('shopify:section:load', scheduleSanitize);

  const main = document.getElementById('MainContent');
  if (main) {
    new MutationObserver(scheduleSanitize).observe(main, { childList: true, subtree: true });
  }
})();
